import { AccessRequestError } from './requestError';

export class AccessRequestResult {
    constructor(user, permission, subject, granted, paid, upgrade) {
        this.user = user;
        this.permission = permission;
        this.subject = subject;
        this.granted = granted;
        this.paid = paid;
        this.upgrade = upgrade;
    }

    get approve() {
        return this.granted && this.paid;
    }

    get billing() {
        return this.user.workspace.billing || {};
    }

    get plan() {
        return this.billing.plan;
    }

    get error() {
        if (!(this._error || this.approve)) {
            const shouldPay = this.granted && !this.paid;

            if (shouldPay) {
                this._error = this.createPayError();
            } else {
                const shouldUpgrade = this.upgrade;

                if (shouldUpgrade) {
                    this._error = this.createUpgradeError(shouldUpgrade);
                } else {
                    this._error = this.createForbiddenError();
                }
            }
        }

        return this._error || null;
    }

    createPayError() {
        return new AccessRequestError(`Pay for ${this.plan}`, 'unpaid', this.plan, this.permission, this.plan);
    }

    createUpgradeError(plan) {
        return new AccessRequestError(`Upgrade to ${plan}`, 'upgrade', this.plan, this.permission, plan);
    }

    createForbiddenError() {
        return new AccessRequestError('Access forbidden', 'forbidden', this.plan, this.permission);
    }
}
